// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__shw1q","left":"Virtual_left__-frq0","wrapper":"Virtual_wrapper__X37ZW"};